import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/legal/refund-policy/global'

export const LEGAL_REFUND_POLICY_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
